import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { usePublishedCollections } from 'marketplace-ui-common/collections/hooks/usePublishedCollections';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { SAMPLE_COLLECTION_IMAGE } from '../../../storybook/stories/CollectionSection.stories';
import { CollectionCard } from '../../components/CollectionCard';
import { Paths } from '../../constants/paths';
import { useAppContext } from '../../context/AppContext';
import { useMemo } from 'react';
import { useCollectionQuery } from '../hooks/useCollectionQuery';
import { useScrollToTop } from '../../hooks/useScrollToTop';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function OtherCollections() {
  var _collectionResult$dat2;
  const collectionResult = useCollectionQuery();
  const scrollToTop = useScrollToTop();
  const {
    getDisplayedCollections
  } = usePublishedCollections({
    appContext: useAppContext(),
    offeringType: 'APP'
  });
  const collections = useMemo(() => getDisplayedCollections().filter(c => {
    var _c$publishedListing, _collectionResult$dat;
    return ((_c$publishedListing = c.publishedListing) === null || _c$publishedListing === void 0 ? void 0 : _c$publishedListing.id) !== ((_collectionResult$dat = collectionResult.data) === null || _collectionResult$dat === void 0 ? void 0 : _collectionResult$dat.id);
  }).sort(() => Math.random() - 0.5).slice(0, 2), [getDisplayedCollections, (_collectionResult$dat2 = collectionResult.data) === null || _collectionResult$dat2 === void 0 ? void 0 : _collectionResult$dat2.id]);
  if (collections.length === 0) return undefined;
  return /*#__PURE__*/_jsxs(View, {
    "data-test-id": "featured-collection-cta",
    paddingBlockStart: "1000",
    children: [/*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      paddingBlockEnd: "400",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        typography: "heading-300",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.featuredCollection.ctaTitle"
        })
      }), /*#__PURE__*/_jsx(UIRouterLink, {
        to: Paths.FEATURED,
        onClick: scrollToTop,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.featuredCollection.ctaLink"
        })
      })]
    }), /*#__PURE__*/_jsx(CardGrid, {
      columns: 2,
      gap: "400",
      children: collections.map(collection => {
        var _collection$published, _collection$published2, _collection$published3, _collection$published4;
        return /*#__PURE__*/_jsx(CollectionCard, {
          use: "on-dark",
          description: collection === null || collection === void 0 || (_collection$published = collection.publishedListing) === null || _collection$published === void 0 ? void 0 : _collection$published.metaDescription,
          imageSrc: SAMPLE_COLLECTION_IMAGE,
          name: collection === null || collection === void 0 || (_collection$published2 = collection.publishedListing) === null || _collection$published2 === void 0 ? void 0 : _collection$published2.name,
          slug: collection === null || collection === void 0 || (_collection$published3 = collection.publishedListing) === null || _collection$published3 === void 0 ? void 0 : _collection$published3.slug,
          collectionId: collection === null || collection === void 0 || (_collection$published4 = collection.publishedListing) === null || _collection$published4 === void 0 ? void 0 : _collection$published4.id
        }, collection.publishedListing.name);
      })
    })]
  });
}